.SoundButton {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--primitives-colors-neutral-0);
  font: var(--font-caption-lg-medium);
  text-align: center;

  svg {
    width: 32px;
    height: 32px;
  }
}